import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { projectPlansKeys } from '../projectPlansKeys'

import { RequestTypes } from '../requestTypes'
import { ProjectPlan } from '@core/entities/project/ProjectPlan/ProjectPlan'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const projectPlansTransform = (plans: ProjectPlan[]) =>
  plans.map((plan) => ProjectPlan.new(plan))

export const useGetProjectPlans = (
  payload: RequestTypes['useGetProjectPlans'],
  options?: UseQueryOptions<ProjectPlan[], RequestErrorType>,
) => {
  return useQuery({
    select: projectPlansTransform,
    ...projectPlansKeys.byProject(payload),
    enabled: !!payload.projectId,
    ...options,
  })
}
